import React from 'react';
import RadioButton from 'components/RadioButton';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const ItemAddress = ({address, addressSelected, customOnClick}) => {
    const selectMethod = () => {
        customOnClick(address);
    }
    if(!address) return '';

    const currentSelected = (addressSelected && addressSelected.value) ? (addressSelected.value.addressId === address.value.addressId) : false;

    return (<li className={"address-item-wrap"+ (address.disabled ? ' disabled' : '')} onClick={() => { selectMethod()}}>
        <RadioButton item={currentSelected}/>
        <span className="address-item-title">
            {address.saved && <span className="address-item-frequently">Dirección frecuente</span>}
            {address.label}
        </span>
    </li>);
}

ItemAddress.propTypes = {
    address: PropTypes.object,
    addressSelected: PropTypes.object,
    customOnClick: PropTypes.func
};

export default ItemAddress;
